// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, WithTagName } from "./Dom";
import { DefaultFormField } from "./WebSite.Form.Field";

export class UriField extends DefaultFormField {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    if (this.input !== null) {
      this.addValueChangedHandler(this.input);
      this.addBlurHandler(this.input);
    }
  }

  determineElements() {
    this.input = new DomQuery(this.element).getChild(WithTagName("INPUT"));
  }
}

interactivityRegistration.register("UriField", function (element) { return new UriField(element); });
